'use strict';

require('../../style/index.less');

require('./index.less');

require('../../checkbox/style');

require('../../button/style');

require('../../input/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/transfer/style/index.tsx
 ** module id = 378
 ** module chunks = 0
 **/